import React from 'react'
import styled, { keyframes } from 'styled-components'

// Full-viewport branded loading state for the public Employer Branding pages.
// Shown while a page's lazy chunk or its data loads, and as the route Suspense
// fallback. A centered spinner on the company's light theme background reads as
// an intentional "loading" state instead of a blank white page. The company
// palette persists in the global theme across route switches, so this paints
// the company's own tint — never browser white.
const EbLoadingScreen: React.FC = () => (
  <Screen>
    <Spinner />
  </Screen>
)

export default EbLoadingScreen

const Screen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.primaryLight};
`

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.colors.primaryFadeLight};
  border-top-color: ${({ theme }) => theme.colors.primary};
  animation: ${spin} 0.8s linear infinite;
`
